import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import Select from '../../../../common/components/Form/Select.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  updateForm,
  useSelector,
} from '../../../../store.js'
import {setShipper} from '../../../../data/shippers.js'
import {showGlobalError} from '../../../GlobalErrorMessage.js'
import {DHL} from '../../../../common/constants/ShipperNames.js'
import {isPresent} from '../../../../common/utils.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import api from '../../../../common/api.js'
import {
  baseSaveParamsSelector,
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
} from '../ShippersFunctions.js'
import className from '../../../../common/className.js'
import TextInput from '../../Common/TextInput.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  const errors = baseShipperFormErrorsSelector(state, {formName})
  const form = formSelector(state, {
    formName,
  })

  if (!isPresent(form.paymentAccountNumber)) {
    errors.paymentAccountNumber = 'Payment account number is required'
    errors.preventSave = true
  }

  return errors
}

export function initialFormSelector(state, {shipper}) {
  const vendorConfig = shipper?.vendor_config || {}

  return {
    ...baseShipperInitialFormSelector(state, {shipper, vendor: DHL}),
    paymentAccountNumber: vendorConfig.payment_account_number || '',
    paymentCountryCode: vendorConfig.payment_country_code || '',
  }
}

export async function saveShipperDHL(formName) {
  const form = formSelector(getState(), {formName})
  let [shipperID, params] = baseSaveParamsSelector(getState(), {formName})

  const {paymentAccountNumber, paymentCountryCode} = form

  params = {
    ...params,
    payment_account_number: paymentAccountNumber,
    payment_country_code: paymentCountryCode,
  }

  updateForm(formName, {isSaving: true})

  try {
    const {json} =
      shipperID !== NEW_ID
        ? await api.put(`/shipper/${shipperID}/`, params)
        : await api.post('/shipper/', {...params, vendor: DHL})

    goToShipperSettings()

    setShipper(json)
  } catch (err) {
    showGlobalError(
      {
        summary: 'There was an error while saving shipper.',
      },
      err,
    )

    updateForm(formName, {isSaving: false})
  }
}

function DHLForm({formName, form}) {
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap clear-both">
      <div className="medium-6 columns">
        <fieldset>
          <ul className="form-list margin-bottom-0">
            {form.id !== NEW_ID && <Nickname formName={formName} />}
            <li
              className={className`form-list-item bigger margin-bottom-20 ${{'margin-top-20 divider--top': form.id !== NEW_ID}}`}
            >
              <TextInput
                label="Payment Account Number"
                name="dhl_acct_no"
                value={form.paymentAccountNumber}
                onChange={(event) =>
                  updateForm(formName, {
                    paymentAccountNumber: event.target.value,
                    hasChanged_paymentAccountNumber: true,
                  })
                }
                errorMessage={
                  form.hasChanged_paymentAccountNumber &&
                  errors.paymentAccountNumber
                }
                required
              />
            </li>
            <li className="form-list-item bigger margin-bottom-20">
              <label htmlFor="id_dhl_country_code">Payment Country Code</label>
              <Select
                name="dhl_country_code"
                value={form.paymentCountryCode}
                onChange={(value) =>
                  updateForm(formName, {paymentCountryCode: value})
                }
              >
                <option value="">Use “From” Address</option>
                <option value="US">US</option>
                <option value="CA">CA</option>
              </Select>
            </li>
            {form.id !== NEW_ID && <ShippingMethods formName={formName} />}
            <li className="list__item list__item--no-style">
              <ButtonPrimary
                isLoading={form.isSaving}
                isDisabled={errors.preventSave}
                onClick={() => saveShipperDHL(formName)}
              >
                {form.id !== NEW_ID ? 'Save' : 'Create'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>
      <div className="medium-5 columns">
        <fieldset>
          <div className="alert margin-bottom-10 alert--standard">
            {form.id === NEW_ID ? (
              <dl className="list">
                <dt className="list__title fs-00 lh-md margin-bottom-5">
                  Need help authorizing your DHL account?
                </dt>
                <dd className="list__item fs-n0 margin-bottom-0">
                  <a
                    className="btn--link mid meta-ups-setup-help"
                    href="https://support.ordoro.com/how-do-i-set-up-dhl-in-ordoro/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Get step-by-step instructions →
                  </a>
                </dd>
              </dl>
            ) : (
              <Archive formName={formName} />
            )}
          </div>
        </fieldset>
      </div>
    </div>
  )
}

export default onlyIfAutoForm(DHLForm, setUpShipperForm)
